// ============================================
// CASA BALA - ASSETS (автоматично зареждане)
// ============================================

// ----- ОСНОВНИ -----
import logoImg from "../assets/images/logo.webp";
import preloaderLogoImg from "../assets/images/preloader-logo.webp";

// ----- ВИДЕА -----
import heroVideoFile from "../assets/videos/hero-loop.mp4";

// ----- ФОНОВЕ И ДЕКОРАЦИИ -----
import formPatternImg from "../assets/images/form-pattern.webp";
import shape1Img from "../assets/images/shape-1.webp";
import shape2Img from "../assets/images/shape-2.webp";
import shape4Img from "../assets/images/shape-4.webp";
import shape5Img from "../assets/images/shape-5.webp";
import shape6Img from "../assets/images/shape-6.webp";

// ----- ОСНОВНИ ИЗОБРАЖЕНИЯ -----
import heroBgImg from "../assets/images/hero/hero-bg.webp";
import gardenImg from "../assets/images/about/garden.webp";
import winesLogoImg from "../assets/images/about/wines-logo.webp";
import interiorImg from "../assets/images/about/interior.webp";
import casabala3Img from "../assets/images/gallery/casabala3.webp";
import proseccoBarImg from "../assets/images/home-main1.webp";
import meatballsImg from "../assets/images/menu/meatballs.webp";
import pizzaFooterImg from "../assets/images/footer/pizza-footer.webp";
import offerings3Img from "../assets/images/home/offerings-3.webp";
import offerings2Img from "../assets/images/home/offerings-2.webp";
import offerings1Img from "../assets/images/home/offerings-1.webp";

// ----- ИКОНИ -----
import featureFreshImg from "../assets/images/icons/feature-fresh.webp";
import featureTastesImg from "../assets/images/icons/feature-tastes.webp";
import featureChefsImg from "../assets/images/icons/feature-chefs.webp";
import featureEventsImg from "../assets/images/icons/feature-events.webp";

// ----- ИЛЮСТРАЦИИ -----
import mainDishSvg from "../assets/images/illustrations-optimized/main-dish.svg";
import saladSvg from "../assets/images/illustrations-optimized/salad.svg";
import antipastiSvg from "../assets/images/illustrations-optimized/antipasti.svg";
import dryAgeSvg from "../assets/images/illustrations-optimized/dry-age.svg";
import pastaSvg from "../assets/images/illustrations-optimized/pasta.svg";
import risottoSvg from "../assets/images/illustrations-optimized/rissoto.svg";
import pizzaSvg from "../assets/images/illustrations-optimized/pizza.svg";
import sideDishSvg from "../assets/images/illustrations-optimized/side-dish.svg";
import brunchSvg from "../assets/images/illustrations-optimized/brunch.svg";
import dessertSvg from "../assets/images/illustrations-optimized/dessert.svg";

// ----- МЕНЮ СЕКЦИИ -----
import lunchMenuImg from "../assets/images/menu-sections/lunch-menu.webp";
import mainMenuImg from "../assets/images/menu-sections/main-menu.webp";
import drinksMenuImg from "../assets/images/menu-sections/drinks-menu.webp";
import alcoholMenuImg from "../assets/images/menu-sections/alcohol-menu.webp";

// ----- СЪБИТИЯ -----
import event1Img from "../assets/images/events/event-1.webp";
import event2Img from "../assets/images/events/event-2.webp";
import event3Img from "../assets/images/events/event-3.webp";
import event4Img from "../assets/images/events/event-4.webp";
import event5Img from "../assets/images/events/event-5.webp";
import event6Img from "../assets/images/events/event-6.webp";
import event7Img from "../assets/images/events/event-7.webp";
import event8Img from "../assets/images/events/event-8.webp";
import event9Img from "../assets/images/events/event-9.webp";
import event10Img from "../assets/images/events/event-10.webp";
import event11Img from "../assets/images/events/event-11.webp";
import event4DetailImg from "../assets/images/events/event-4-detail.webp";
import event5DetailImg from "../assets/images/events/event-5-detail.webp";
import event6DetailImg from "../assets/images/events/event-6-detail.webp";
import event7DetailImg from "../assets/images/events/event-7-detail.webp";
import event8DetailImg from "../assets/images/events/event-8-detail.webp";
import event9DetailImg from "../assets/images/events/event-9-detail.webp";
import event10DetailImg from "../assets/images/events/event-10-detail.webp";
import event11DetailImg from "../assets/images/events/event-11-detail.webp";

// ============================================
// АВТОМАТИЧНО ЗАРЕЖДАНЕ НА ГАЛЕРИЯТА
// ============================================

// Функция за автоматично зареждане на всички изображения от папка
const importAllGalleryImages = () => {
  try {
    // Зарежда всички изображения от папката gallery
    const images = [];
    const galleryContext = require.context('../assets/images/gallery', false, /\.(webp|svg)$/);
    
    galleryContext.keys().forEach((key) => {
      // Добавяме изображението
      images.push(galleryContext(key));
    });
    
    // Сортираме по име на файл за консистентна подредба
    return images.sort((a, b) => {
      // Извличаме имената на файловете за сравнение
      const nameA = a.split('/').pop();
      const nameB = b.split('/').pop();
      return nameA.localeCompare(nameB);
    });
  } catch (error) {
    console.warn('Грешка при зареждане на галерията:', error);
    return [];
  }
};

// АВТОМАТИЧНО зареждане на ВСИЧКИ снимки от папката gallery
export const GALLERY_PHOTOS = importAllGalleryImages();

// ============================================
// ЕКСПОРТОВЕ
// ============================================

// ----- ОСНОВНИ -----
export const LOGO = logoImg;
export const PRELOADER_LOGO = preloaderLogoImg;

// ----- ВИДЕА -----
export const HERO_VIDEO = heroVideoFile;

// ----- ФОНОВЕ И ДЕКОРАЦИИ -----
export const FORM_PATTERN = formPatternImg;
export const SHAPE_1 = shape1Img;
export const SHAPE_2 = shape2Img;
export const SHAPE_4 = shape4Img;
export const SHAPE_5 = shape5Img;
export const SHAPE_6 = shape6Img;

// ----- ОСНОВНИ -----
export const HERO_IMAGE = heroBgImg;
export const GARDEN = gardenImg;
export const WINES_AND_LOGO = winesLogoImg;
export const RESTAURANT_INTERIOR = interiorImg;
export const casabala_3 = casabala3Img;
export const PROSECCO_BAR = proseccoBarImg;
export const MEATBALLS = meatballsImg;
export const PIZZA_FOOTER = pizzaFooterImg;
export const OFFERINGS_1 = offerings1Img;
export const OFFERINGS_2 = offerings2Img;
export const OFFERINGS_3 = offerings3Img;

// ----- ИКОНИ -----
export const FEATURE_ICONS = [
  featureFreshImg,
  featureTastesImg,
  featureChefsImg,
  featureEventsImg,
];

// ----- ИЛЮСТРАЦИИ -----
export const CATEGORY_ILLUSTRATIONS = {
  MAIN: mainDishSvg,
  SALAD: saladSvg,
  STARTER: antipastiSvg,
  SOUP: dryAgeSvg,
  PASTA: pastaSvg,
  RISOTTO: risottoSvg,
  PIZZA: pizzaSvg,
  SIDES: sideDishSvg,
  BREAD: brunchSvg,
  DESSERT: dessertSvg,
};

// ----- МЕНЮ СЕКЦИИ -----
export const MENU_SECTION_IMAGES = {
  LUNCH: lunchMenuImg,
  MAIN: offerings2Img,
  DRINKS: drinksMenuImg,
  ALCOHOL: offerings3Img,
};

// ----- СЪБИТИЯ -----
export const EVENT_BG = {
  e1: event1Img,
  e2: event2Img,
  e3: event3Img,
  e4: event4Img,
  e5: event5Img,
  e6: event6Img,
  e7: event7Img,
  e8: event8Img,
  e9: event9Img,
  e10: event10Img,
  e11: event11Img,
  e4_detail: event4DetailImg,
  e5_detail: event5DetailImg,
  e6_detail: event6DetailImg,
  e7_detail: event7DetailImg,
  e8_detail: event8DetailImg,
  e9_detail: event9DetailImg,
  e10_detail: event10DetailImg,
  e11_detail: event11DetailImg,
};

// ----- ПОМОЩНА ФУНКЦИЯ (за удобство) -----
export const cbAsset = (path) => path;
